import { useEffect, useState } from 'react';
import axios from 'axios';

// One request per page load, shared by every component that needs the list
let cached = null;
let inFlight = null;

const fetchCategoryPages = () => {
  if (!inFlight) {
    inFlight = axios.get('/api/deals/category-pages')
      .then((res) => { cached = res.data.categories || []; return cached; })
      .catch((err) => { inFlight = null; throw err; });
  }
  return inFlight;
};

/** The server renders the current category page's entry into the HTML (see app.js). */
const readEmbeddedCategory = () => {
  try {
    const el = document.getElementById('category-page-data');
    return el ? JSON.parse(el.textContent) : null;
  } catch {
    return null;
  }
};

/**
 * Categories that have a /category/:slug landing page: [{ name, slug, count, maxPercentOff }].
 * @returns {{ categoryPages: object[], loaded: boolean, error: boolean }}
 */
export const useCategoryPages = () => {
  const [state, setState] = useState({ categoryPages: cached || [], loaded: Boolean(cached), error: false });

  useEffect(() => {
    if (cached) return undefined;
    let active = true;
    fetchCategoryPages()
      .then((list) => active && setState({ categoryPages: list, loaded: true, error: false }))
      .catch(() => active && setState({ categoryPages: [], loaded: true, error: true }));
    return () => { active = false; };
  }, []);

  return state;
};

/**
 * The landing-page entry for `slug`. On the first page load it comes from the HTML,
 * so the page can render immediately; after in-app navigation it comes from the API.
 * @returns {{ category: object|null, loaded: boolean }}
 */
export const useCategoryPage = (slug) => {
  const embedded = readEmbeddedCategory();
  const { categoryPages, loaded } = useCategoryPages();
  if (embedded && embedded.slug === slug) return { category: embedded, loaded: true };
  return { category: categoryPages.find((c) => c.slug === slug) || null, loaded };
};

export default useCategoryPages;
